import React from 'react';
import { Music2 } from 'lucide-react';
import Reveal from './Reveal';
import { setlist } from '../mock';

const Setlist = () => {
  return (
    <section id="setlist" className="py-24 md:py-32 bg-[#f5efe7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="text-center mb-14">
          <p className="text-[#e6396b] tracking-[0.4em] text-[12px] font-semibold mb-5">
            SETLIST
          </p>
          <h2 className="font-serif text-[44px] md:text-[64px] text-[#1a1a1a] font-medium">
            Songs You'll Hear
          </h2>
          <p className="mt-4 text-[16px] text-[#6a6a6a] max-w-xl mx-auto">
            A two-hour journey through Fleetwood Mac's greatest moments — from
            <em> Rumours</em> to <em>Tango in the Night</em>.
          </p>
        </Reveal>

        <div className="max-w-4xl mx-auto grid sm:grid-cols-2 gap-x-10 gap-y-2">
          {setlist.map((song, i) => (
            <Reveal key={song.title} delay={i * 40}>
              <div className="group flex items-center gap-4 py-4 border-b border-[#e7ddd0] hover:border-[#e6396b]/60 transition-colors">
                <span className="font-serif text-[#e6396b] text-[15px] tabular-nums w-8">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <Music2
                  size={16}
                  className="text-[#cf2a5b] opacity-0 group-hover:opacity-100 transition-opacity"
                />
                <div className="flex-1 flex items-baseline justify-between gap-3">
                  <span className="font-serif text-[20px] md:text-[22px] text-[#1a1a1a] font-medium leading-tight">
                    {song.title}
                  </span>
                  <span className="text-[11px] tracking-[0.18em] text-[#9a9a9a] italic font-light text-right">
                    {song.era}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <p className="text-center mt-10 text-[14px] text-[#6a6a6a] italic">
          … plus a few surprises every night.
        </p>
      </div>
    </section>
  );
};

export default Setlist;
